
export const whitespaceRegex = /\s\s+|\t/g;
export const newlineRegex = /(?:\r\n|\r|\n)/g; // Replaces \r\n, \r and \n to make all types of messages in one line